import { render, staticRenderFns } from "./StudentRegister.vue?vue&type=template&id=12218c4a&scoped=true&"
import script from "./StudentRegister.vue?vue&type=script&lang=js&"
export * from "./StudentRegister.vue?vue&type=script&lang=js&"
import style0 from "./StudentRegister.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StudentRegister.vue?vue&type=style&index=1&id=12218c4a&scoped=true&lang=css&"
import style2 from "./StudentRegister.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12218c4a",
  null
  
)

export default component.exports